// Install the components
export function install(Vue) {
  // General message wrapper
  Vue.prototype.$message = function(msg, options) {
    // Define toast settings
    const settings = Object.assign(
      {
        type: 'info',
      },
      options,
    );
    // Call vue-toasted
    this.$toasted.show(msg, settings);
    if (this.loggedIn && this.user) {
      const notifiable = this.user;
      // Build notification object
      const object = {
        message: msg,
        type: settings.type,
        user_id: notifiable._id,
      };
      // Save in notifications
      this.$store.dispatch(`notifications/add`, {
        object,
        callback: data => {
          console.log('Notification saved:', data);
        },
      });
    }
  };
  // Info
  Vue.prototype.$info = function(msg, options) {
    // Define toast settings
    const settings = Object.assign(
      {
        type: 'info',
      },
      options,
    );
    // Call vue-toasted wrapper
    this.$message(msg, settings);
  };
  // Success
  Vue.prototype.$success = function(msg, options) {
    // Define toast settings
    const settings = Object.assign(
      {
        type: 'success',
      },
      options,
    );
    // Call vue-toasted wrapper
    this.$message(msg, settings);
  };
  // Error
  Vue.prototype.$error = function(msg, options) {
    // Define toast settings
    const settings = Object.assign(
      {
        type: 'error',
      },
      options,
    );
    // Call vue-toasted wrapper
    this.$message(msg, settings);
  };
  // Warning
  Vue.prototype.$warning = function(msg, options) {
    // Define toast settings
    const settings = Object.assign(
      {
        type: 'warning',
      },
      options,
    );
    // Call vue-toasted wrapper
    this.$message(msg, settings);
  };
}

// Plugin
const plugin = {
  /* eslint-disable no-undef */
  version: '1.0',
  install,
};

export default plugin;
